import { 
  LayoutGrid, 
  Users, 
  TrendingUp, 
  Gavel, 
  ArrowUpRight,
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/common/Card';
import { Button } from '../../components/common/Button';
import { Badge } from '../../components/common/Badge';

export const Home = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-3xl font-bold text-slate-900">Welcome back, {user?.username}</h1>
        <p className="text-slate-500">Here's what's happening in your ecosystem today.</p>
      </header>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-600">
                <TrendingUp size={20} />
              </div>
              <Badge variant="success">+12%</Badge>
            </div>
            <div className="mt-4">
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">Reputation</p>
              <h3 className="text-2xl font-bold text-slate-900">{user?.reputation}</h3>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-lg bg-emerald-100 flex items-center justify-center text-emerald-600">
                <Users size={20} />
              </div>
              <Badge variant="secondary">Active</Badge>
            </div>
            <div className="mt-4">
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">Connections</p>
              <h3 className="text-2xl font-bold text-slate-900">{user?.connectionsCount}</h3>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-lg bg-amber-100 flex items-center justify-center text-amber-600">
                <LayoutGrid size={20} />
              </div>
              <Badge variant="primary">8 New</Badge>
            </div>
            <div className="mt-4">
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">Apps Used</p>
              <h3 className="text-2xl font-bold text-slate-900">24</h3>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center justify-between">
              <div className="h-10 w-10 rounded-lg bg-purple-100 flex items-center justify-center text-purple-600">
                <Gavel size={20} />
              </div>
              <Badge variant="warning">3 Voting</Badge>
            </div>
            <div className="mt-4">
              <p className="text-sm font-medium text-slate-500 uppercase tracking-wider">Proposals</p>
              <h3 className="text-2xl font-bold text-slate-900">12</h3>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <Card className="lg:col-span-2">
          <CardHeader className="flex-row items-center justify-between space-y-0">
            <div>
              <CardTitle>Recommended Apps</CardTitle>
              <CardDescription>Based on your activity and circles</CardDescription>
            </div>
            <Button variant="outline" size="sm">View All</Button>
          </CardHeader>
          <CardContent>
            <div className="grid gap-4 sm:grid-cols-2">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="flex items-center space-x-4 rounded-xl border border-slate-100 p-4 transition-colors hover:bg-slate-50">
                  <div className="h-12 w-12 rounded-xl bg-slate-200" />
                  <div className="flex-1">
                    <h4 className="font-semibold text-slate-900">App Name {i}</h4>
                    <p className="text-xs text-slate-500">Productivity • 4.8★</p>
                  </div>
                  <Button variant="ghost" size="icon">
                    <ArrowUpRight size={18} />
                  </Button>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
            <CardDescription>Latest updates from your network</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="flex space-x-4">
                <div className="h-2 w-2 mt-2 rounded-full bg-indigo-600" />
                <div>
                  <p className="text-sm text-slate-900">
                    <span className="font-semibold">Alex Rivera</span> joined the <span className="font-semibold">Design Circle</span>
                  </p>
                  <p className="text-xs text-slate-500 mt-1">2 hours ago</p>
                </div>
              </div>
            ))}
            <Button variant="ghost" className="w-full text-indigo-600">View Feed</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
